import ScienceBehindWlTrackingMacrosPoster from "../../../../../images/posters/fbbc/education/science-behind.webp";
import MenopausePart1Poster from "../../../../../images/posters/fbbc/education/menopause-p1.webp";

const fbbcEducation = [
  {
    "title": "Science Behind WL & Tracking Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Science+of+Weight+Loss+and+Tracking+Macros.mp4",
    "thumbnail": ScienceBehindWlTrackingMacrosPoster,
    "length": "29:08"
  },
  {
    "title": "Menopause: Impact on Metabolism & Body Composition",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Menopause+Part+1.mp4",
    "thumbnail": MenopausePart1Poster,
    "length": "31:28"
  },
];

export default fbbcEducation; 